import React, { useEffect, useRef, useState } from "react";
import { InputText } from "primereact/inputtext";
// import { ProgressSpinner } from "primereact/progressspinner";
import styles from "./index.module.scss";
import { formatPhoneNumber } from "../../../utils/utils";

interface propsTypes {
  value: string;
  placeholder?: string;
  setValue: (value: string) => void;
  isLoading: boolean;
  investorObj?: any;
  setInvestorObj?: any;
  className?: string;
  data: any;
  disabled?: boolean;
  showContactOwner: boolean;
}

export default function SearchBarWithOption(props: propsTypes) {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const [key, setKey] = useState("");
  const [showSuggestions, setShowSuggestions] = useState(false);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (key !== "Backspace") {
      props.setValue(e.target.value);
      setShowSuggestions(true);
    } else {
      props.setValue(e.target.value);
      props.setInvestorObj(null);
      setShowSuggestions(true);
    }
  };

  const handleSuggestionClick = (suggestion: any) => {
    props.setValue(suggestion.fullName);
    props.setInvestorObj(suggestion);
    setShowSuggestions(false);
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (
      wrapperRef.current &&
      !wrapperRef.current.contains(event.target as Node)
    ) {
      setShowSuggestions(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div
      ref={wrapperRef}
      className={`${styles.searchBox} ${props.className} ${
        props.disabled && styles.disabledInput
      }`}
    >
      <InputText
        disabled={props.disabled}
        placeholder={props.placeholder}
        value={props.value}
        onChange={handleInputChange}
        onKeyDown={(e) => {
          setKey(e.key);
        }}
        className={styles.input}
      />
      {!props.disabled && (
        <>
          {/* {!props.isLoading ? ( */}
          <img
            src="/images/arrow-down.svg"
            alt=""
            onClick={() => setShowSuggestions(!showSuggestions)}
          />
          {/*  ) : (
             <ProgressSpinner
               style={{ width: "1.5rem", height: "1.5rem" }}
               strokeWidth="8"
               fill="var(--surface-ground)"
               animationDuration=".5s"
             />
           )} */}
        </>
      )}
      {showSuggestions && props?.data?.length > 0 && (
        <div className={styles.suggestions}>
          {props?.data &&
            props.data.map((suggestion: any) => (
              <div
                key={suggestion?.id}
                className={styles.fullName}
                onClick={() => handleSuggestionClick(suggestion)}
              >
                <div className={styles.name}>
                  {suggestion?.firstName} {suggestion?.lastName}
                </div>
                {suggestion?.email && (
                  <div className={styles.email}>{suggestion.email}</div>
                )}
                {suggestion?.plainMobile && (
                  <div className={styles.phone}>
                    {formatPhoneNumber(suggestion?.plainMobile)}
                  </div>
                )}
                <div className={styles.email}>
                  Account Name: {suggestion?.acctDetail?.[0]?.name}
                </div>
                {props.showContactOwner && suggestion?.contactOwner && (
                  <div className={styles.phone}>
                    Contact Owner: {suggestion?.contactOwner[0]?.contactOwner}
                  </div>
                )}
                {props.showContactOwner && suggestion?.contactOwner && (
                  <div className={styles.phone}>
                    Investor Status: {suggestion?.investorStatus || "N/A"}
                  </div>
                )}
              </div>
            ))}
        </div>
      )}
    </div>
  );
}
